<template>
  <div :class="['sidebar-wrapper', { placement }]">
    <div v-if="$slots.header" class="header">
      <slot name="header" />
    </div>
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { SidebarPlacement } from '../types/sidebar-placement';

export default defineComponent({
  name: 'SidebarInnerWrapper',
  props: {
    placement: {
      type: String,
      default: SidebarPlacement.Left,
    },
  },
});
</script>
<style lang="scss" scoped>
.sidebar-wrapper {
  height: 100%;
  background-color: var(--white);
  border-radius: var(--radius-medium);

  .header {
    padding: var(--spacing-150) var(--spacing-150) var(--spacing-100) var(--spacing-150);
    border-bottom: 2px solid var(--gray-92);
  }

  &.placement-left {
    border-right: 1px;
  }

  &.placement-right {
    border-left: 1px;
  }
}
</style>
